import { DIMENSION } from './walls.mjs';

const DELTAS = {
  up:    { dx: 0,  dy: -1, exitSide: 'top',    entrySide: 'bottom' },
  down:  { dx: 0,  dy:  1, exitSide: 'bottom', entrySide: 'top'    },
  left:  { dx: -1, dy:  0, exitSide: 'left',   entrySide: 'right'  },
  right: { dx:  1, dy:  0, exitSide: 'right',  entrySide: 'left'   },
};

function slide(robotPositions, walls, color, direction) {
  const { dx, dy, exitSide, entrySide } = DELTAS[direction];
  let { x, y } = robotPositions[color];

  while (true) {
    if (walls[`${x},${y}`]?.[exitSide]) break;
    const nx = x + dx;
    const ny = y + dy;
    if (nx < 0 || nx >= DIMENSION || ny < 0 || ny >= DIMENSION) break;
    if (walls[`${nx},${ny}`]?.[entrySide]) break;
    if (Object.values(robotPositions).some(p => p.x === nx && p.y === ny)) break;
    x = nx;
    y = ny;
  }
  return { x, y };
}

function getReachableTiles(robotPositions, walls, color) {
  return ['up', 'down', 'left', 'right']
    .map(dir => ({ direction: dir, ...slide(robotPositions, walls, color, dir) }))
    .filter(({ x, y }) => {
      const start = robotPositions[color];
      return x !== start.x || y !== start.y;
    });
}

export { slide, getReachableTiles };
